var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9131 33.3286C31.093 33.0516 32.2489 32.859 33.3566 32.5219C37.0409 31.4142 39.0878 28.8616 39.7139 25.1291C40.0269 23.2388 40.1233 21.3484 39.5574 19.4822C39.2323 18.4106 38.7145 17.4353 37.9801 16.5805C37.7634 16.3276 37.7032 16.1229 37.7995 15.7858C38.3293 14.04 38.1607 12.3062 37.5466 10.6085C37.4864 10.4399 37.1854 10.2232 37.0289 10.2473C36.2824 10.3556 35.5118 10.4279 34.8255 10.7168C33.7419 11.1744 32.7425 11.8005 31.683 12.3302C31.4542 12.4386 31.1532 12.5108 30.9124 12.4627C27.493 11.6439 24.0855 11.6439 20.6661 12.4506C20.4132 12.5108 20.0761 12.4506 19.8473 12.3182C18.3784 11.4152 16.8854 10.5483 15.1396 10.2713C14.2125 10.1028 14.1041 10.163 13.8513 11.066C13.3937 12.6674 13.3094 14.2808 13.7911 15.9062C13.8392 16.0627 13.8031 16.3035 13.6947 16.424C11.7081 18.7959 11.3589 21.5531 11.7562 24.4789C12.0091 26.3572 12.5509 28.1272 13.7429 29.6322C15.26 31.5466 17.343 32.4496 19.6547 32.9312C20.3049 33.0637 20.9551 33.16 21.6654 33.2804C20.9189 34.0871 20.5457 35.0022 20.353 36.0015C20.329 36.146 20.1483 36.3146 19.9918 36.3868C17.5356 37.4464 15.3202 36.736 13.8874 34.4483C13.1529 33.2684 12.1777 32.4015 10.7569 32.1486C10.492 32.1005 10.191 32.1245 9.92611 32.1727C9.36021 32.2931 9.28797 32.5941 9.70938 33.0155C9.85387 33.16 10.0224 33.3045 10.203 33.4129C11.3228 34.063 12.1174 35.0383 12.5148 36.2183C13.3696 38.8069 15.9102 39.9146 18.6192 39.6618C19.137 39.6136 19.6547 39.5414 20.2567 39.4571C20.2567 40.9019 20.2928 42.3107 20.2447 43.7194C20.2206 44.502 19.4741 44.8632 18.6192 44.5742C16.6928 43.9241 14.8747 43.0331 13.2252 41.8411C6.65114 37.0731 3.40025 30.5954 3.61697 22.4923C3.90594 12.0533 11.6358 3.19163 21.8942 1.34946C33.8141 -0.793724 45.2765 7.14086 47.5642 19.121C49.6351 30.0295 43.5066 40.8056 33.1278 44.4779C31.8877 44.9114 31.2736 44.4779 31.2857 43.1535C31.2977 41.2993 31.2977 39.4571 31.3218 37.6029C31.3218 36.0256 31.0569 34.5326 29.9131 33.3286Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_85",
    x: 0.606812,
    y: 0,
    width: 52.358,
    height: 51.6732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_85",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.4ac5e523dbd089dce3fdcdd15b825583.svg";
export { ForwardRef as ReactComponent };